import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "main-content",
  class: "ml-64 p-8"
}
const _hoisted_2 = { class: "bg-white rounded-lg shadow-sm border border-gray-200" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center items-center h-48"
}
const _hoisted_4 = {
  key: 1,
  class: "p-12 text-center text-gray-400"
}
const _hoisted_5 = {
  key: 2,
  class: "overflow-x-auto"
}
const _hoisted_6 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_7 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_8 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_9 = { class: "text-sm text-gray-900" }
const _hoisted_10 = { class: "text-xs text-gray-400" }
const _hoisted_11 = { class: "px-6 py-4 text-sm font-mono text-gray-700 max-w-xs" }
const _hoisted_12 = ["title"]
const _hoisted_13 = {
  key: 1,
  class: "text-gray-400 italic"
}
const _hoisted_14 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-600" }
const _hoisted_15 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_16 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 3,
  class: "px-6 py-4 border-t border-gray-200"
}
const _hoisted_19 = { class: "flex items-center justify-between" }
const _hoisted_20 = { class: "text-sm text-gray-500" }
const _hoisted_21 = { class: "font-medium text-gray-700" }
const _hoisted_22 = { class: "font-medium text-gray-700" }
const _hoisted_23 = { class: "font-medium text-gray-700" }
const _hoisted_24 = { class: "flex items-center space-x-2" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "px-3 py-1.5 bg-green-700 text-white rounded-md text-sm font-medium" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "space-y-5"
}
const _hoisted_29 = { class: "flex flex-wrap gap-3 text-xs" }
const _hoisted_30 = { class: "inline-flex items-center px-2.5 py-1 rounded-md bg-gray-100 text-gray-600 font-mono" }
const _hoisted_31 = { class: "inline-flex items-center px-2.5 py-1 rounded-md bg-gray-100 text-gray-600 font-mono" }
const _hoisted_32 = { class: "bg-gray-900 text-green-300 text-xs rounded-md p-4 overflow-x-auto whitespace-pre-wrap break-words max-h-52" }
const _hoisted_33 = { class: "bg-gray-900 text-green-300 text-xs rounded-md p-4 overflow-x-auto whitespace-pre-wrap break-words max-h-52" }

import { onMounted, ref } from 'vue';
import { useAPIKeysStore } from '@/store/apikeys';
import type { APIRequest } from '@/config/types/responses';
import Header from '../components/header.vue';
import SideBar from '../components/sidebar.vue';
import Modal from '../components/modal.vue';

const PAGE_SIZE = 10;


export default /*@__PURE__*/_defineComponent({
  __name: 'apirequests',
  setup(__props) {

const apiKeyStore = useAPIKeysStore();

const showModal = ref(false);
const selectedRequest = ref<APIRequest | null>(null);
const currentPage = ref(1);
function loadPage(page: number) {
  const purpose = localStorage.getItem('purpose');
  if (purpose === 'public') {
    apiKeyStore.getAPIRequests(page, PAGE_SIZE);
  } else if (purpose === 'local') {
    apiKeyStore.getAdminAPIRequests(page, PAGE_SIZE);
  }
}

function changePage(page: number) {
  currentPage.value = page;
  loadPage(page);
}

onMounted(() => loadPage(currentPage.value));

function openModal(req: APIRequest) {
  selectedRequest.value = req;
  showModal.value = true;
}

function formatDate(input: string) {
  if (!input) return '—';
  const date = new Date(input);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  }).format(date);
}

function formatTime(input: string) {
  if (!input) return '';
  const date = new Date(input);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date);
}

function prettyJson(raw: string) {
  if (!raw) return '—';
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
}

function statusClass(status: string) {
  const code = parseInt(status, 10);
  if (code >= 200 && code < 300) return 'px-2 py-0.5 text-xs font-semibold rounded-full bg-green-100 text-green-700';
  if (code >= 400 && code < 500) return 'px-2 py-0.5 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-700';
  if (code >= 500) return 'px-2 py-0.5 text-xs font-semibold rounded-full bg-red-100 text-red-700';
  return 'px-2 py-0.5 text-xs font-semibold rounded-full bg-gray-100 text-gray-600';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createVNode(SideBar),
    _createElementVNode("main", _hoisted_1, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "mb-8" }, [
        _createElementVNode("h2", { class: "text-2xl font-bold text-green-800" }, "API Requests"),
        _createElementVNode("p", { class: "mt-1 text-gray-500 text-sm" }, "Audit log of all API calls made through your keys")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        (_unref(apiKeyStore).loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[3] || (_cache[3] = [
              _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-green-600" }, null, -1)
            ])))
          : (!_unref(apiKeyStore).apiRequests?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[4] || (_cache[4] = [
                _createElementVNode("i", { class: "fa-solid fa-inbox text-4xl mb-3" }, null, -1),
                _createElementVNode("p", { class: "text-sm" }, "No API requests found", -1)
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("table", _hoisted_6, [
                  _cache[6] || (_cache[6] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Timestamp"),
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Endpoint"),
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Organization"),
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "HTTP Status"),
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Details")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(apiKeyStore).apiRequests, (req) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: req.id,
                        class: "hover:bg-gray-50 transition-colors"
                      }, [
                        _createElementVNode("td", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(formatDate(req.createdAt)), 1),
                          _createElementVNode("div", _hoisted_10, _toDisplayString(formatTime(req.createdAt)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_11, [
                          (req.endpoint)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                title: req.endpoint,
                                class: "block truncate max-w-xs cursor-default"
                              }, _toDisplayString(req.endpoint), 9, _hoisted_12))
                            : (_openBlock(), _createElementBlock("span", _hoisted_13, "No endpoint"))
                        ]),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(req.orgnizationName || '—'), 1),
                        _createElementVNode("td", _hoisted_15, [
                          _createElementVNode("span", {
                            class: _normalizeClass(statusClass(req.httpStatus))
                          }, _toDisplayString(req.httpStatus || '—'), 3)
                        ]),
                        _createElementVNode("td", _hoisted_16, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (openModal(req)),
                            class: "inline-flex items-center px-3 py-1.5 text-xs font-medium text-green-700 bg-green-50 border border-green-200 rounded-md hover:bg-green-100 transition-colors"
                          }, _cache[5] || (_cache[5] = [
                            _createElementVNode("i", { class: "fa-solid fa-code mr-1.5" }, null, -1),
                            _createTextVNode(" View Payload ", -1)
                          ]), 8, _hoisted_17)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])),
        (!_unref(apiKeyStore).loading && _unref(apiKeyStore).pagination.totalPages > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _cache[7] || (_cache[7] = _createTextVNode(" Page ", -1)),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(currentPage.value), 1),
                  _cache[8] || (_cache[8] = _createTextVNode(" of ", -1)),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(apiKeyStore).pagination.totalPages), 1),
                  _cache[9] || (_cache[9] = _createTextVNode("  ·  ", -1)),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(apiKeyStore).pagination.totalRows), 1),
                  _cache[10] || (_cache[10] = _createTextVNode(" total records ", -1))
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (changePage(currentPage.value - 1))),
                    disabled: currentPage.value <= 1,
                    class: "px-3 py-1.5 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                  }, _cache[11] || (_cache[11] = [
                    _createElementVNode("i", { class: "fa-solid fa-chevron-left mr-1" }, null, -1),
                    _createTextVNode("Previous ", -1)
                  ]), 8, _hoisted_25),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(currentPage.value), 1),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (changePage(currentPage.value + 1))),
                    disabled: currentPage.value >= _unref(apiKeyStore).pagination.totalPages,
                    class: "px-3 py-1.5 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                  }, _cache[12] || (_cache[12] = [
                    _createTextVNode(" Next", -1),
                    _createElementVNode("i", { class: "fa-solid fa-chevron-right ml-1" }, null, -1)
                  ]), 8, _hoisted_27)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(Modal, {
        show: showModal.value,
        title: "Request & Response Payload",
        size: "max-w-3xl",
        onClose: _cache[2] || (_cache[2] = ($event: any) => (showModal.value = false))
      }, {
        default: _withCtx(() => [
          (selectedRequest.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("span", _hoisted_30, [
                    _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fa-solid fa-clock mr-1.5 text-gray-400" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(formatDate(selectedRequest.value.createdAt)) + " " + _toDisplayString(formatTime(selectedRequest.value.createdAt)), 1)
                  ]),
                  _createElementVNode("span", _hoisted_31, [
                    _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fa-solid fa-link mr-1.5 text-gray-400" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(selectedRequest.value.endpoint), 1)
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(['inline-flex items-center px-2.5 py-1 rounded-md font-semibold', statusClass(selectedRequest.value.httpStatus)])
                  }, _toDisplayString(selectedRequest.value.httpStatus || '—'), 3)
                ]),
                _createElementVNode("div", null, [
                  _cache[15] || (_cache[15] = _createElementVNode("h4", { class: "text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 flex items-center" }, [
                    _createElementVNode("i", { class: "fa-solid fa-arrow-up-from-bracket mr-2 text-blue-400" }),
                    _createTextVNode("Request ")
                  ], -1)),
                  _createElementVNode("pre", _hoisted_32, _toDisplayString(prettyJson(selectedRequest.value.request)), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[16] || (_cache[16] = _createElementVNode("h4", { class: "text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 flex items-center" }, [
                    _createElementVNode("i", { class: "fa-solid fa-arrow-down-to-bracket mr-2 text-emerald-400" }),
                    _createTextVNode("Response ")
                  ], -1)),
                  _createElementVNode("pre", _hoisted_33, _toDisplayString(prettyJson(selectedRequest.value.response)), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ], 64))
}
}

})